import type { GameStats } from "@grundbesitz/shared";
import { TokenIcon } from "../board/TokenIcon";
import { colorHex, formatMoney } from "../../lib/format";
import type { RankedPlayer } from "./resultLogic";

/** Rent, purchases and doubles per player. */
export function StatsTable({ ranking, stats }: { ranking: RankedPlayer[]; stats: GameStats }) {
  return (
    <div className="overflow-x-auto" role="region" aria-label="Statistik je Spieler" tabIndex={0}>
      <table className="w-full min-w-[30rem] border-collapse text-left">
        <caption className="sr-only">Statistik je Spieler</caption>
        <thead>
          <tr className="border-b border-line text-sm text-ink-2">
            <th scope="col" className="py-2 pr-4 font-medium">
              Spieler
            </th>
            <th scope="col" className="px-3 py-2 text-right font-medium">
              Miete erhalten
            </th>
            <th scope="col" className="px-3 py-2 text-right font-medium">
              Miete gezahlt
            </th>
            <th scope="col" className="px-3 py-2 text-right font-medium">
              Straßen gekauft
            </th>
            <th scope="col" className="py-2 pl-3 text-right font-medium">
              Pasche
            </th>
          </tr>
        </thead>
        <tbody className="tabular-nums">
          {ranking.map(({ player }) => (
            <tr key={player.id} className="border-b border-line">
              <th scope="row" className="py-2.5 pr-4 text-left font-medium text-ink">
                <span className="flex items-center gap-2">
                  <span aria-hidden="true" className="size-3 shrink-0 rounded-full" style={{ background: colorHex(player.color) }} />
                  <TokenIcon token={player.token} color={player.color} size={20} />
                  <span className="truncate">{player.name}</span>
                </span>
              </th>
              <td className="px-3 py-2.5 text-right text-ink">{formatMoney(stats.rentCollected[player.id] ?? 0)}</td>
              <td className="px-3 py-2.5 text-right text-ink">{formatMoney(stats.rentPaid[player.id] ?? 0)}</td>
              <td className="px-3 py-2.5 text-right text-ink">{stats.propertiesBought[player.id] ?? 0}</td>
              <td className="py-2.5 pl-3 text-right text-ink">{stats.doubles[player.id] ?? 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
